import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 11.125C3 10.527 3.492 10 4.125 10H5.25V8.875c0-.598.492-1.125 1.125-1.125H7.5V6.625c0-.598.492-1.125 1.125-1.125h6.75c.598 0 1.125.527 1.125 1.125V7.75h1.125c.598 0 1.125.527 1.125 1.125V10h1.125c.598 0 1.125.527 1.125 1.125v6.75c0 .633-.527 1.125-1.125 1.125h-2.25v-3.937c0-.282-.281-.563-.562-.563a.58.58 0 0 0-.563.563V19h-2.25v-3.937c0-.282-.281-.563-.562-.563a.58.58 0 0 0-.563.563V19h-2.25v-3.937c0-.282-.281-.563-.562-.563a.58.58 0 0 0-.563.563V19H7.5v-3.937c0-.282-.281-.563-.562-.563a.58.58 0 0 0-.563.563V19h-2.25A1.11 1.11 0 0 1 3 17.875z"
    }, null, -1)
  ]))]))
}
export default { render: render }